/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Organizationnameplaceholder3Inputs */

const zh_organizationsettings_organizationnameplaceholder3 = /** @type {(inputs: Organizationsettings_Organizationnameplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组织名称`)
};

const en_organizationsettings_organizationnameplaceholder3 = /** @type {(inputs: Organizationsettings_Organizationnameplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization name`)
};

const es_organizationsettings_organizationnameplaceholder3 = /** @type {(inputs: Organizationsettings_Organizationnameplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de la organización`)
};

/**
* | output |
* | --- |
* | "Organization name" |
*
* @param {Organizationsettings_Organizationnameplaceholder3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_organizationnameplaceholder3 = /** @type {((inputs?: Organizationsettings_Organizationnameplaceholder3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Organizationnameplaceholder3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_organizationnameplaceholder3(inputs)
	if (locale === "en") return en_organizationsettings_organizationnameplaceholder3(inputs)
	return es_organizationsettings_organizationnameplaceholder3(inputs)
});
export { organizationsettings_organizationnameplaceholder3 as "organizationSettings_organizationNamePlaceholder" }